// extracted by mini-css-extract-plugin
export var blockquote = "index-module--blockquote--HWmLQ";
export var quoteContainer = "index-module--quoteContainer----5j5";
export var quoteIcon = "index-module--quoteIcon--ns9s7";
export var quoteImage = "index-module--quoteImage--yqO9Q";
export var smallIcon = "index-module--smallIcon--dINKv";